"use strict";

window.CKEDITOR_BASEPATH = "/lib/ckeditor/";
